import { render, staticRenderFns } from "./DraggableWrapper.vue?vue&type=template&id=6a349ed9&scoped=true&"
import script from "./DraggableWrapper.ts?vue&type=script&lang=ts&"
export * from "./DraggableWrapper.ts?vue&type=script&lang=ts&"
import style0 from "./DraggableWrapper.scss?vue&type=style&index=0&id=6a349ed9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a349ed9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
